'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = stubSessionFactory;

var _wildemitter = require('wildemitter');

var _wildemitter2 = _interopRequireDefault(_wildemitter);

var _logger = require('../../utils/logger');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var logger = (0, _logger.create)('Stub session');

var forEach = function forEach(obj, func) {
    return Object.keys(obj).forEach(function (key) {
        func(key, obj[key]);
    });
};

function getTopicFromSubscription(selectorSet) {
    if (selectorSet.startsWith('#>')) {
        return selectorSet.substr(2).split('////>');
    }
    return [selectorSet];
}

function stubSessionFactory(topicDictionary, delayedActions) {
    var subscribedTopics = [];
    var emitter = new _wildemitter2.default();
    var session = {
        stream: topicDictionary.getValue,
        subscribe: function subscribe(selectorSet) {
            subscribedTopics = subscribedTopics.concat(selectorSet);
            logger.debug('Subscribe: ' + selectorSet);
            getTopicFromSubscription(selectorSet).filter(function (topic) {
                return delayedActions.get(topic);
            }).forEach(function (topic) {
                setTimeout(delayedActions.execute(topic, topicDictionary.update), 0);
            });
            return {
                on: function on(eventName, handler) {
                    return getTopicFromSubscription(selectorSet).forEach(function (singleTopic) {
                        return handler(null, singleTopic);
                    });
                }
            };
        },
        unsubscribe: function unsubscribe(topic) {
            subscribedTopics = subscribedTopics.filter(function (item) {
                return item !== topic;
            });
            logger.debug('Unsubscribe: ' + topic);
        },
        on: function on(config) {
            forEach(config, emitter.on.bind(emitter));
            return session;
        },
        off: function off(config) {
            forEach(config, emitter.off.bind(emitter));
            return session;
        },
        close: function close() {
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            emitter.emit.apply(emitter, ['close'].concat(args));
        },
        emit: emitter.emit.bind(emitter),
        getSubscribedTopics: function getSubscribedTopics() {
            return [].concat(_toConsumableArray(subscribedTopics));
        }
    };
    return session;
}


//////////////////
// WEBPACK FOOTER
// ./~/rp-diffusion-connector/lib/providers/stub/stubSessionFactory.js
// module id = 2224
// module chunks = 1